import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByLinkQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByLinkQueryType,
  AnalyticsSalesByLinkQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByLinkQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByLinkQueryType,
    AnalyticsSalesByLinkQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByLinkQueryType,
    AnalyticsSalesByLinkQueryVariablesType
  >(AnalyticsSalesByLinkQuery, options);
};
